import React from 'react'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import { t } from 'i18next'
import Ovulos from '@resources/imgs/tratament-2.png'
import Embriao from '@resources/imgs/tratament-1.png'
import Trompas from '@resources/imgs/tratament-3.png'
import Hospital from '@resources/imgs/hospital.svg'
import IOrder from '@interfaces/IOrder'
import OrderStatusEnum from '@enums/OrderStatusEnum'
import OrderTypeEnum from '@enums/OrderTypeEnum'
import { formatOrderDate } from '../utils/formatOrderDate'
import 'react-circular-progressbar/dist/styles.css'

interface OrderSummaryProps {
  inProgressOrder: IOrder | null
  totalProgress: number
}

const OrderSummary: React.FC<OrderSummaryProps> = ({ inProgressOrder, totalProgress }) => {
  const isCanceled = inProgressOrder?.status === OrderStatusEnum.CANCELED

  const getTreatmentIcon = () => {
    const treatment = inProgressOrder?.treatment_type
    if (treatment === 'ICSI') return Ovulos
    if (treatment === 'FIV') return Embriao
    if (treatment === 'Inseminação' || treatment === 'IIU') return Trompas
    return Embriao // default fallback
  }

  return (
    <>
      <section className="summary-area mt-5" style={{
        opacity: isCanceled ? 0.7 : 1,
        filter: isCanceled ? 'grayscale(0.5)' : 'none',
        transition: 'all 0.3s ease'
      }}
      >
        <div className="text mb-4">
          <h5 className="mb-2">Confira em qual etapa está o seu pedido</h5>
          <p className="text-muted">Siga o passo a passo para finalizar a aquisição e liberar o envio para a clínica.</p>
        </div>

        <div className="summary-order-card">
          <div className="summary-order-header">
            <div className="order-progress-section">
              <figure className="mb-0 progress-circle">
                <CircularProgressbar
                  value={totalProgress}
                  text={`${totalProgress}%`}
                  styles={buildStyles({
                    pathColor: '#fff',
                    textColor: '#fff',
                    trailColor: 'rgba(255, 255, 255, 0.2)',
                    backgroundColor: '#3e98c7',
                  })}
                />
              </figure>
              <div className="order-main-info">
                <span className="order-label">Pedido</span>
                <h4 className="order-id-text mb-0">{inProgressOrder?.internal_id || '-'}</h4>
              </div>
            </div>
            <div className="order-status-badge">
              <span className="status-text">{t(`fields.${inProgressOrder?.status}`) || '-'}</span>
            </div>
          </div>

          <div className="summary-order-details">
            <div className="detail-item">
              <div className="detail-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 2V5M16 2V5M3.5 9.09H20.5M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="detail-content">
                <span className="detail-label">DATA</span>
                <span className="detail-value">{formatOrderDate(inProgressOrder?.created_at)}</span>
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 3H9C7.05 8.84 7.05 15.16 9 21H8M15 3C16.95 8.84 16.95 15.16 15 21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16M3 9C8.84 7.05 15.16 7.05 21 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="detail-content">
                <span className="detail-label">TIPO</span>
                <span className="detail-value">{inProgressOrder?.order_type ? (inProgressOrder.order_type === OrderTypeEnum.CUSTOM_IMPORT ? 'Importação Personalizada' : 'Pronta Entrega') : '-'}</span>
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <img src={getTreatmentIcon()} alt="Tratamento" />
              </div>
              <div className="detail-content">
                <span className="detail-label">TRATAMENTO</span>
                <span className="detail-value">{inProgressOrder?.treatment_type || '-'}</span>
              </div>
            </div>

            <div className="detail-item">
              <div className="detail-icon">
                <img src={Hospital} alt="Clínica" />
              </div>
              <div className="detail-content">
                <span className="detail-label">CLÍNICA</span>
                <span className="detail-value">{inProgressOrder?.clinic?.trading_name || inProgressOrder?.clinic?.company_name || '-'}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default OrderSummary
